import React, { useState } from "react";
import axios from "../../API/axios";
import SuccessToast from "../SuccessToast";
import WarningToast from "../WarningToast";
import ErrorToast from "../ErrorToast";
import { Form } from "react-router-dom";

const ChangeEmailAddress = () => {
  const [newEmail, setNewEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);

  const [warningToastMessage, setWarningToastMessage] = useState("");
  const [showWarningToast, setShowWarningToast] = useState(false);

  const [errorToastMessage, setErrorToastMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);

  const handleChangeEmail = async () => {
    const sessionId = localStorage.getItem("sessionId");
    const token = localStorage.getItem("token");

    if (!sessionId || !token) {
      setErrorToastMessage("Authentication error. Please log in again.");
      setShowErrorToast(true);
      setLoading(false);
      return;
    }

    const data = {
      deviceType: "Web",
      sessionId: sessionId,
      newEmail: newEmail,
      password: password,
    };

    try {
      const response = await axios.post("/Account/ChangeEmailAddress", data);
      setToastMessage(response.data.message || "Email updated successfully.");
      setShowToast(true);
      setNewEmail("");
      setPassword("");
    } catch (error) {
      if (error.response && error.response.status === 404) {
        setWarningToastMessage(error.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(error.response.data.message);
        setShowErrorToast(true);
      }
    }
  };

  return (
    <>
      <div className="setting-header">
        <h4>Change Email Address</h4>
      </div>
      <div className="p-3 privacy">
        <div className="mb-3">
          <Form>
            <div className="row settings">
              <div className="col-12 mt-2 ps-0 mb-2 userInput">
                <label className="mb-0">New Email Address</label>
                <input
                  type="email"
                  className="form-control"
                  value={newEmail}
                  onChange={(e) => setNewEmail(e.target.value)}
                  placeholder="Enter new email"
                />
              </div>
              <div className="col-12 ps-0 mb-3">
                <label className="mb-0">Password</label>
                <input
                  type="password"
                  className="form-control"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Enter password"
                />
              </div>

              <div className="text-end">
                <button
                  type="button"
                  className="mainBtn1 mt-3 text-center"
                  onClick={handleChangeEmail}
                  disabled={loading}
                >
                  {loading ? "Updating..." : "Update Email"}
                </button>
              </div>
            </div>
          </Form>
        </div>

        <SuccessToast
          show={showToast}
          message={toastMessage}
          onClose={() => setShowToast(false)}
        />
        <WarningToast
          show={showWarningToast}
          message={warningToastMessage}
          onClose={() => setShowWarningToast(false)}
        />
        <ErrorToast
          show={showErrorToast}
          message={errorToastMessage}
          onClose={() => setShowErrorToast(false)}
        />
      </div>
    </>
  );
};

export default ChangeEmailAddress;
